// trigger size selector if product is not ready to order
export default function triggerSizeSelector() {
    $('body').on('click', '.add-to-cart.not-ready.trigger-size-selector', (e) => {
        e.stopImmediatePropagation();
        $(e.currentTarget)
            .closest('.product-detail__info')
            .find('.custom-options-container')
            .addClass('open');
    });
}
